
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { skyaccessData } from './skyaccess-data';
import { IItem, ModuleTypes, PageTypes, IWelcomePage, IConfigPage, IBusiness, IITemModuleList, IItemList, IDoorList, DOOR_STATE, IMultiProperties, EntryTypes, IEmailTmplates, IEmails, IPerson } from 'src/app/metadata/interfaces/page/Pages';
import { Router, Data } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as localForage from "localforage";
import { SkyaccessApiService } from './skyaccess-api.service';
import { ApiConstant } from 'src/app/constants/app.constant';


declare const Cryptography: any;
// import 'src/app/services/aesjs.js';


@Injectable()
export class SkyaccessApp {

  private BaseUrl: string;
  private IsDebug: boolean = true;
  private TmpTk: any;

  public _GnSetting: IItem[];
  public _WelcomePages: IWelcomePage;
  public _Pers: any;
  public _Properties: IMultiProperties[];
  public _ConfigPage: IConfigPage;
  public _ModuleList: IItem[];
  public _ModuleList2: IItem[];
  public _AccDrView: IItem[];
  public _Doors: IDoorList[];
  public _Businesses: IBusiness;
  public _ChatsView: IItem[];
  public _TestDt: any;


  constructor(private httpClient: HttpClient, private _router: Router, private skyAPIService: SkyaccessApiService) {

    // navigator.storage.estimate().then ( (_storageStats) => {
    //   ("Storage stats :" + _storageStats);
    // });

    // if (navigator.storage && navigator.storage.persist) 
    //     navigator.storage.persist().then(granted => {
    //     if (granted)
    //       ("Storage will persist and not be cleared");
    //     else
    //       ("Storage won’t persist and may be cleared");
    //   });
    // navigator.storageageQuota.queryInfo("temporary").then(function(info) { 
    //   (info.quota); // The total amount in bytes 
    //   (info.usage); // How much data you’ve used so far in bytes 
    //
    // this.BaseUrl2 ="https://www.skyaccess.us/integrawebapi/api/v1/WirelessTask/OpenDoor2/1" 
    // this.BaseUrl ="http://localhost:7535/api/v1/SkyAccessDesign/GetSkyAccessDesign/111111";
    // this.BaseUrl3 ="http://localhost:7535/api/v1/SkyAccessDesign/GetSkyAccessDesign";

    //this.BaseUrl = "http://localhost:7535/api/v1/";
    // this.BaseUrl = "https://www.skyaccess.eu/IntegraDevApi/api/skyaccessdesign/";
    this.BaseUrl =  ApiConstant.baseUrlCoreApi;
    //this.BaseUrl = "http://40.68.46.178/integrawebapi/api/v1/"; 
    this.IsDebug = false;

    // this._GnSetting = skyaccessData._GnSetting;
    // this._WelcomePages = skyaccessData._WelcomePages;
    this._Pers = skyaccessData._Person;
    
    
  // this._Properties = skyaccessData._Properties;


    // this._ConfigPage = skyaccessData._ConfigPage;

    var ConfigPage = (val: any): void => {
      this._ConfigPage = val;
    
      
      
    }
    // this.GetConfigSettings().subscribe(ConfigPage);

    // this._ModuleList2 = skyaccessData._ModuleList2;
    // this._ModuleList = skyaccessData._ModuleList;
    // this._AccDrView = skyaccessData._AccDrView;
    // this._Doors = skyaccessData._DoorList;
    // this._Businesses = skyaccessData._Businesses;
    // this._ChatsView = skyaccessData._ChatsView;

    //this.Logdata("this._router.url : " + this._router.url);

  }


  LogDB(Fct: string, data: string, All: any) {
    return;
    
  }

  Logdata(Tmp: any) {
    return;
    
  }

  LogEx(Tmp: any) {
    
  }


  ClearAllNgswCache() {
    return;
    try {
      caches.keys().then((keys) => {
        keys.forEach((eachCacheName) => {
          
          let regExPat = /^ngsw:/;
          if (regExPat.test(eachCacheName)) {
            

            caches.open(eachCacheName).then((eachCache) => {
              


              eachCache.keys().then((requests) => {
                requests.forEach((eachRequest) => { eachCache.delete(eachRequest); });
              });
            });
          }
        });
      });
    }
    catch (ex) {
      this.LogEx("ClearAllNgswCache :" + ex.message);
    }
  }


  ClearAllNgswCacheAll() {
    return;
    try {
      caches.keys().then((keys) => {
        keys.forEach((eachCacheName) => {
          alert(eachCacheName);
          // //   let regExPat = /^ngsw:/;
          //   if (regExPat.test(eachCacheName)) { 
          caches.delete(eachCacheName);
          // }
        });
      });

      alert("Cache deleted !");
    }
    catch (ex) {
      this.LogEx("ClearAllNgswCache :" + ex.message);
    }
  }


  ClearAllStorage() {
    return;

    try {

      localForage.clear();
    }
    catch (ex) {
      this.LogEx("ClearAllStorage :" + ex.message);
    }
  }


  ClearCookies() {
    return;

    try {
      var cookies = document.cookie.split("; ");
      for (var c = 0; c < cookies.length; c++) {
        var d = window.location.hostname.split(".");
        while (d.length > 0) {
          var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
          var p = location.pathname.split('/');
          document.cookie = cookieBase + '/';
          while (p.length > 0) {
            document.cookie = cookieBase + p.join('/');
            p.pop();
          };
          d.shift();
        }
      }
    }
    catch (ex) {
      this.LogEx("ClearCookies :" + ex.message);
    }
  }



  //#region collection  

  async SaveDesign(Tmp: IItem[], pd: string) {
    try {
      this.Logdata("saving SaveGeneraSettg...");
      await this.SaveGeneraSettg(Tmp, pd);

      this.Logdata("saving SaveModule1...");
      await this.SaveModule1(Tmp, pd);

      this.Logdata("saving SaveModule2...");
      await this.SaveModule2(Tmp, pd);

      this.Logdata("saving SaveChatView...");
      await this.SaveChatView(Tmp, pd);

      this.Logdata("saving SaveAcDrView...");
      await this.SaveAcDrView(Tmp, pd);

      this.Logdata("saving SaveWelcomePage...");
      // await this.SaveWelcomePage(Tmp, pd);

      this.Logdata("saving SaveConfigSettings...");
      // await this.SaveConfigSettings(Tmp, pd);

      this.Logdata("saving SaveBusinessDetails...");
      // await this.SaveBusinessDetails(Tmp, pd);
    }
    catch (ex) {
      this.LogEx("IsDesignReceived :" + ex.message);
      return false;
    }
  }

  public IsDesignReceived(Tmp: IItem[]): boolean {
    try {
      let _Tmp: IItem[] = Tmp.filter(x => x.ModuleType == ModuleTypes.NotAModule && x.PageType == PageTypes.SA_GenSetting);
      if ((_Tmp != null || _Tmp != undefined) && _Tmp.length > 0)
        return true;
      else
        return false;
    }
    catch (ex) {
      this.LogEx("IsDesignReceived :" + ex.message);
      return false;
    }
  }


  public async GetSetReload(callback: (data: string) => any, Get: boolean) {
    try {
      if (Get)
        await localForage.getItem("reload").then((val: any) => { callback(val); });
      else
        await localForage.setItem("reload", "reload");
    }
    catch (ex) {
      this.LogEx("GetSetReload :" + ex.message);
    }
  }

  public getAllPages(){
    return this.skyAPIService.getPages();
  }

  public setAllPages(data){
    this.skyAPIService.skyAccessData = data;
  }

  public getPageDataRef(){
    return this.skyAPIService.skyAccessData;
  }


  public SaveGeneraSettg(Tmp: IItem[], p: string) {
    return this.skyAPIService.setGnSettings(Tmp);
  }

  public GetGeneralSettg(callback?: (param: any) => any) {
    return this.skyAPIService.getGnSetting();

  }

  public SaveModule1(Tmp: IItem[], p: string) {
    return this.skyAPIService.setModuleList1(Tmp);

  }

  public GetModule1(callback?: (param: any) => any) {
    return this.skyAPIService.getModuleList1();

  }


  public SaveModule2(Tmp: IItem[], p: string) {
    return this.skyAPIService.setModuleList2(Tmp);
  }


  public GetModule2(callback?: (param: any) => any) {
    return this.skyAPIService.getModuleList2();

  }

  public SaveWelcomePage(Tmp: IWelcomePage, p: string) {
    return this.skyAPIService.setWelcomePage(Tmp);

  }

  public GetWelcomePage(callback?: (param: any) => any) {
    return this.skyAPIService.getWelcomePage();

  }

  public createBusinessDetailsTemplate(items: IItem[]){
    return this.skyAPIService.createNewBusinessDetailsTemplate(items);
  }

  public deleteBusinessDetailsTemplate(items: IItem[]){
    return this.skyAPIService.deleteBusinessDetailsTemplate(items);
  }

  public SaveBusinessDetails(Tmp: IBusiness, p: string) {
    return this.skyAPIService.setBusinesses(Tmp);
  }


  public GetBusinessDetails(callback?: (param: any) => any) {
    return this.skyAPIService.getBusinesses();

  }

  public async SaveChatView(Tmp: IItem[], p: string) {

    if (this.IsDebug)
      return;

    try {
      let _Tmp: IItem[] = Tmp.filter(x => x.ModuleType == ModuleTypes.NotAModule && x.PageType == PageTypes.SA_ChatView);
      
      
      
      await localForage.setItem("ChView", this.EncryptData64(JSON.stringify(_Tmp))).then((value) => { this.LogDB("SaveChatView", null, value); });

    }
    catch (ex) {
      this.LogEx("SaveChatView :" + ex.message);
    }
  }


  public async GetChatView(callback: (param: any) => any) {


    if (this.IsDebug) {
      callback(skyaccessData._AccDrView);
      //  return skyaccessData._ChatsView;
    }

    var Tmp: any;
    try {
      await localForage.getItem("ChView").then(async (value1: any) => {
        this.LogDB("ChView", null, value1);

        if (value1 == undefined || value1 == null) {
          
          await localForage.setItem("ChView", this.EncryptData64(JSON.stringify(skyaccessData._ChatsView))).then((value2) => {
            Tmp = JSON.parse(this.DecryptData64(value2));
            callback(Tmp);
          });
        }
        else {
          Tmp = JSON.parse(this.DecryptData64(value1));
          callback(Tmp);
        }

      });

      return Tmp;
    }
    catch (ex) {
      this.LogEx("GetChatView : " + ex.message);
      return "";
    }

  }

  public async SaveAcDrView(Tmp: IItem[], p: string) {


    if (this.IsDebug)
      return;

    try {
      let _Tmp: IItem[] = Tmp.filter(x => x.ModuleType == ModuleTypes.NotAModule && x.PageType == PageTypes.SA_DrAccView);
      
      await localForage.setItem("DrView", this.EncryptData64(JSON.stringify(_Tmp))).then((value) => { this.LogDB("SaveAcDrView", null, value); });
    }
    catch (ex) {
      this.LogEx("SaveAcDrView :" + ex.message);
    }

  } 

  public async GetAcDrView(callback: (param: any) => any) {

    if (this.IsDebug) {
      callback(skyaccessData._AccDrView);
      //  return skyaccessData._AccDrView;
    }

    var Tmp: any;
    try {
      await localForage.getItem("DrView").then(async (value1: any) => {
        this.LogDB("GetAcDrView", null, value1);

        if (value1 == undefined || value1 == null) {
          await localForage.setItem("DrView", this.EncryptData64(JSON.stringify(skyaccessData._AccDrView))).then((value2) => {
            Tmp = JSON.parse(this.DecryptData64(value2));
            callback(Tmp);
          });
        }
        else {
          Tmp = JSON.parse(this.DecryptData64(value1));
          callback(Tmp);
        }

      });

      return Tmp;
    }
    catch (ex) {
      this.LogEx("GetAcDrView : " + ex.message);
      return "";
    }

  }

  public async GetBusinessList(callback: (param: any) => any) {

    if (this.IsDebug) {
      callback(skyaccessData._ModuleList);
      // return skyaccessData._ModuleList;
    }

    var Tmp: any;
    try {
      await localForage.getItem("ML1").then(async (value1: any) => {
        this.LogDB("GetBusinessList", null, value1);

        if (value1 == undefined || value1 == null) {
          await localForage.setItem("ML1", this.EncryptData64(JSON.stringify(skyaccessData._ModuleList))).then((value2) => {
            Tmp = JSON.parse(this.DecryptData64(value2));
            callback(Tmp);
          });
        }
        else {
          Tmp = JSON.parse(this.DecryptData64(value1));
          callback(Tmp);
        }

      });

      return Tmp;
    }
    catch (ex) {
      this.LogEx("GetBusinessList : " + ex.message);
      return "";
    }

  }

  public SaveConfigSettings(Tmp: IConfigPage, p: string) {
    return this.skyAPIService.setConfigPage(Tmp);
  }

  public GetConfigSettings(callback?: (param: any) => any) {
    return this.skyAPIService.getConfigPage();
  }

  public async SavePers(_Tmp: any) {

    if (this.IsDebug)
      return;

    try {
      
      await localForage.setItem("Per", this.EncryptData64(JSON.stringify(_Tmp))).then((value) => { this.LogDB("SavePers", null, value); });

    }
    catch (ex) {
      this.LogEx("SavePers :" + ex.message);
    }

  }

  // public GetDoorLists(): any {

  //   if(this.IsDebug)
  //   return skyaccessData._DoorList;

  //   try {

  //   let Tmp2: any = localForage.getItem("Per");
  //   if (Tmp2 != undefined || Tmp2 != null) {
  //     let Tmp = JSON.parse(this.DecryptData(Tmp2));

  //     let _DoorList: IDoorList[] = [];

  //     let DrN = Tmp._Data2.split(',');
  //     let DrID = Tmp._Doors.split(',');

  //     
  //      

  //     // let Func = Tmp._Data3.split(',');
  //     // let Locat = Tmp._Data3.split(',');

  //     for (let i: any = 0; i < DrN.length - 1; i++) {
  //       if (DrN[i] != "" || DrID[i] != "" || DrID[i] != undefined || DrN[i] != undefined || DrID[i] != null || DrN[i] != null) {
  //         let door: any = {
  //           DriD: DrID[i],
  //           DrName: DrN[i],
  //           DrStatus: DOOR_STATE.NORMAL_CLOSE,
  //           DrLocation: "", // Locat[i]
  //           DrFunction: 0 //Func[i], 
  //         }; 
  //         _DoorList.push(door);

  //       }
  //     }

  //     return _DoorList;
  //   }

  //   // localForage.setItem("DefDr", this.EncryptData(JSON.stringify(skyaccessData._DoorList)));
  //   // return JSON.parse(this.DecryptData(localForage.getItem("DefDr")));

  //    return skyaccessData._DoorList; 
  //   }
  //   catch(ex) {
  //    this.Logdata("GetDoorLists :"+ ex.message); 
  //    return "";
  //   } 
  // }

  public async GetDoorLists(callback: (param: any) => any) {

    if (this.IsDebug) {
      callback(skyaccessData._DoorList);
      //  return skyaccessData._DoorList;
    }

    var Tmp: any;
    try {
      await localForage.getItem("Per").then((value1: any) => {
        this.LogDB("GetDoorLists", null, value1);

        if (value1 != undefined || value1 != null) {
          let Tmp = JSON.parse(this.DecryptData64(value1));

          let _DoorList: IDoorList[] = [];

          let DrN = Tmp._Data2.split(',');
          let DrID = Tmp._Doors.split(',');

          for (let i: any = 0; i < DrN.length - 1; i++) {
            if (DrN[i] != "" || DrID[i] != "" || DrID[i] != undefined || DrN[i] != undefined || DrID[i] != null || DrN[i] != null) {
              let door: any = {
                DriD: DrID[i],
                DrName: DrN[i],
                DrStatus: DOOR_STATE.NORMAL_CLOSE,
                DrLocation: "", // Locat[i]
                DrFunction: 0 //Func[i],

              };

              _DoorList.push(door);
            }
          }

          callback(_DoorList);
        }
        else {
          Tmp = skyaccessData._DoorList;
          callback(Tmp);
        }

      });

      return Tmp;
    }
    catch (ex) {
      this.LogEx("GetDoorLists : " + ex.message);
      return "";
    }

  }


  public IsPerReceived(tmp: any): boolean {
    try {
      this.Logdata("per :" + JSON.stringify(tmp));

      if (tmp != null && tmp != undefined && tmp._Doors != null && tmp._Doors.length > 0)
        return true;
      else
        return false;

    }
    catch (ex) {
      this.LogEx("IsDesignReceived :" + ex.message);
      return false;
    }


  }

  isLinkValid(tmp: any): boolean {
    try {
      let TmpDt = this.DecryptData(tmp);
      this.Logdata("Date time:  " + TmpDt);

      if (TmpDt != null && TmpDt != undefined) {
        return true;

        var CurentDt = new Date();
        let dt = new Date(Date.parse(TmpDt));

        if (CurentDt.getTime() >= dt.getTime())
          return false;
        else
          return true;

      }

      return false;
    }
    catch (ex) {
      this.LogEx("isLinkValid :" + ex.message);
      return false;
    }

  }

  public async GetPerson(callback: (param: any) => any) {

    if (this.IsDebug) {
      callback(skyaccessData._Person);
      // return skyaccessData._Person;
    }
    var Tmp: any;
    try {
      await localForage.getItem("Per").then(async (value1: any) => {
        this.LogDB("GetPerson", null, value1);

        if (value1 == undefined || value1 == null) {
          await localForage.setItem("Per", this.EncryptData64(JSON.stringify(skyaccessData._Person))).then((value2) => {
            Tmp = JSON.parse(this.DecryptData64(value2));
            callback(Tmp);
          });
        }
        else {
          Tmp = JSON.parse(this.DecryptData64(value1));
          callback(Tmp);
        }

      });

      return Tmp;
    }
    catch (ex) {
      this.LogEx("GetPerson : " + ex.message);
      return "";
    }

  }

  // public GetPerson(): any {

  //   if(this.IsDebug)
  //   return skyaccessData._Person;

  //   try {
  //         let Tmp = localForage.getItem("Per");

  //         if (Tmp == undefined || Tmp == null)
  //           return skyaccessData._Person;
  //         else
  //           return JSON.parse(this.DecryptData(Tmp));

  //     }
  //     catch(ex) {
  //       this.Logdata("GetPerson :"+ ex.message); 
  //       return "";
  //     }
  // }

  public async GetProperties(callback: (param: any) => any) {
    //alert("get  GetProperties ");

    if (this.IsDebug) {
      callback(skyaccessData._Properties);
      //return skyaccessData._Properties;
    }

    var Tmp: any;
    try {
      await localForage.getItem("MultP").then(async (value1: any) => {
        this.LogDB("GetProperties", null, value1);

        if (value1 == undefined || value1 == null) {
          await localForage.setItem("MultP", this.EncryptData64(JSON.stringify(skyaccessData._Properties))).then((value2) => {
            Tmp = JSON.parse(this.DecryptData64(value2));
            callback(Tmp);
          });
        }
        else {
          Tmp = JSON.parse(this.DecryptData64(value1));
          callback(Tmp);
        }

      });

      return Tmp;
    }
    catch (ex) {
      this.LogEx("GetProperties : " + ex.message);
      return "";
    }

  }

  // public GetProperties(): any { 

  //   if(this.IsDebug)
  //   return skyaccessData._Properties;

  //   try {

  //         let Tmp = localForage.getItem("MultP"); 
  //         if (Tmp == undefined || Tmp == null)
  //           return skyaccessData._Properties;
  //         else
  //           return JSON.parse(this.DecryptData(Tmp));
  //   }
  //   catch(ex) {
  //    this.Logdata("GetProperties :"+ ex.message); 
  //    return "";
  //   }

  // }

  public async SaveProperty(tmp: IMultiProperties) {
    if (this.IsDebug)
      return;


    try {
      await localForage.getItem("MultP").then(async (value1: string) => {

        let Tmp2: any = value1;

        let Mp: IMultiProperties[] = [];
        if (Tmp2 != undefined || Tmp2 != null) {
          let Mp: IMultiProperties[] = JSON.parse(this.DecryptData64(Tmp2));
          let MpID = Mp.findIndex(s => s._SystemC == tmp._SystemC);
          if (MpID != -1)
            Mp.splice(MpID, 1);
        }

        Mp.push(tmp);

        if (Mp.length > 0)
          await localForage.setItem("MultP", this.EncryptData64(JSON.stringify(Mp))).then((value) => { this.LogDB("SaveProperty", null, value); });
        else
          await localForage.setItem("MultP", this.EncryptData64(JSON.stringify(skyaccessData._Properties))).then((value) => { this.LogDB("SaveProperty", null, value); });
      });

    }
    catch (ex) {
      this.LogEx("SaveProperty :" + ex.message);
    }
  }

  //#endregion 


  //#region Utils

  getHex(val: number): string {
    let str: string = ("0" + (Number(val).toString(16))).slice(-8).toUpperCase();
    while (str.length < 8)
      str = "0" + str;

    return str
  }

  public SaveHashs(Hash: string, TK: string /*, sysc: number, pN: string, pAdrr: string*/) {

    if (Hash != undefined || Hash != null)
      window.localStorage.setItem("Hash", Hash);

    if (TK != undefined || TK != null)
      localForage.setItem("TK", TK);

  }


  // public async SaveHashs(Hash: string, TK: string /*, sysc: number, pN: string, pAdrr: string*/) {
  //   try {
  //         if (Hash != undefined || Hash != null)
  //         await  localForage.setItem("Hash", Hash).then( (value) => { this.LogDB("SaveHashs - Hash", null, value); } );

  //         if (TK != undefined || TK != null)
  //         await localForage.setItem("TK", TK).then( (value) => { this.LogDB("SaveProperty - TK", null, value); } );

  //   }
  //   catch(ex) {
  //    this.Logdata("SaveHashs :"+ ex.message);  
  //   }

  // let _Properties : IMultiProperties[] = [];
  // let Tmp1 : string = localForage.getItem("_Proper") 
  // if(Tmp1 == undefined)
  // {
  //   var TmpOb = { 
  //     _SystemC : sysc,
  //     _Tok : TK,
  //     _PropName : pN,
  //     _PropAddress: pAdrr,
  //     _Hash: Hash  
  //   };  
  //   _Properties.push(TmpOb);
  // }
  // else
  // { 
  // }

  /* store her the Multiprop */

  //}


  public GetHash(): any {
    // return;
    let base64: string = window.localStorage.getItem("Hash")
    let TmpPd: string = Cryptography.TmpConst;
    var t = atob(base64);
    var pd = t.substr(0, 2) + t.substr(8, 2) + t.substr(14, 2) + t.substr(6, 2);
    var k = "@" + pd + TmpPd.substr(9, 7);

    Cryptography.TmpHash = k;
    return { i: parseInt(t.substr(0, 8), 16), s: parseInt(t.substr(8, 8), 16) };
  }


  // public async GetHash() {
  //   try { 
  //     await localForage.getItem("Hash").then( (value: string) => { 

  //           let base64: string =  value; 

  //           let TmpPd: string = Cryptography.TmpConst;
  //           var t = atob(base64);
  //           var pd = t.substr(0, 2) + t.substr(8, 2) + t.substr(14, 2) + t.substr(6, 2);
  //           var k = "@" + pd + TmpPd.substr(9, 7);

  //           Cryptography.TmpHash = k;
  //           return { i: parseInt(t.substr(0, 8), 16), s: parseInt(t.substr(8, 8), 16) };

  //         } );

  //     }
  //     catch(ex) {
  //     this.Logdata("GetHash :"+ ex.message); 
  //     return "";
  //     }
  // }


  public EncryptData(Data: string): string {
    try {
      return Data;

      this.GetHash();
      return Cryptography.Encrypt(Data);

    }
    catch (ex) {
      this.LogEx("EncryptData :" + ex.message);
      return "";
    }
  }


  public DecryptData(Data: string): string {
    try {
      return Data;

      this.GetHash();
      return Cryptography.Decrypt(Data);
    }
    catch (ex) {
      this.LogEx("DecryptData :" + ex.message);
      return "";
    }
  }


  public EncryptData64(Data: string): string {
    try {
      return Data;

      this.GetHash();
      return btoa(Cryptography.Encrypt(Data));

    }
    catch (ex) {
      this.LogEx("EncryptData :" + ex.message);
      return "";
    }
  }


  public DecryptData64(Data: string): string {
    try {
      return Data;

      this.GetHash();
      return Cryptography.Decrypt(atob(Data));
    }
    catch (ex) {
      this.LogEx("DecryptData :" + ex.message);
      return "";
    }
  }


  public async GetTK() {
    try {
      await localForage.getItem("TK").then((value: string) => {
        if (value == undefined || value == null)
          return "";

        this.TmpTk = this.DecryptData(value);
      });
    }
    catch (ex) {
      this.LogEx("GetTK :" + ex.message);
      return "";
    }

  }


  private handleError(errorResponse: HttpErrorResponse) {


    if (errorResponse.error instanceof ErrorEvent) {

      //alert("Request error : " + errorResponse.error.message)
      console.error('Client Side Error :', errorResponse.error.message);

    } else {
      //alert("Request error : " + JSON.stringify(errorResponse))
      console.error('Server Side Error :', JSON.stringify(errorResponse));
    }
    return throwError('There is a problem with the service. We are notified & working on it. Please try again later.');
  }


  //#endregion

  //#region Calls

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //Access-Control-Allow-Methods' :'GET, POST, DELETE, PUT, OPTIONS' 
      //'Authorization': 'my-auth-token'
    })
  };

  SK_GetItems(ITem: IItem): Observable<IItem[]> {
    let Url = this.BaseUrl + "SkyAccessDesign/GetSkyAccessDesign";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, ITem, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }

  SK_UpdateItems(ITems: IItem[]): Observable<IItem[]> {
    let Url = this.BaseUrl + "SkyAccessDesign/UpdateSkyAccessDesign";
    this.GetTK()

    return this.httpClient.post<IItem[]>(Url, ITems, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }

  SK_DeleteItems(ITems: IItem[]): Observable<IItem[]> {
    let Url = this.BaseUrl + "SkyAccessDesign/DeleteSkyAccessDesign";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, ITems, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }

  SK_CreateItems(ITems: IItem[]): Observable<IItem[]> {
    let Url = this.BaseUrl + "SkyAccessDesign/CreateSkyAccessDesign";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, ITems, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }


  SK_GetPerson(Data: any): Observable<IItem[]> {
    let Url = this.BaseUrl + "UserCommon/GetTargetUserCommon";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, Data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }


  SK_GetPersonFromFp(FingerPrint: any): Observable<IPerson> {
    let Url = this.BaseUrl + "UserCommon/GetUserCommonFromFP/" + FingerPrint;
    this.GetTK();

    return this.httpClient.post<IPerson>(Url, FingerPrint, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));
  }


  SK_UpdatePerFingerPrint(Person: Data): Observable<IPerson> {
    let Url = this.BaseUrl + "UserCommon/UpdateFingerPrint";
    this.GetTK()

    return this.httpClient.post<IPerson>(Url, Person, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));
  }


  SK_TriggerEmulation(Data: any): Observable<IItem[]> {
    let Url = this.BaseUrl + "WirelessTask/SK_OpenDoorByGuest";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, Data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }

  SK_TriggerEmergencyOpening(Data: any): Observable<IItem[]> {
    let Url = this.BaseUrl + "WirelessTask/SK_EmergencyOpening";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, Data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }


  SK_TriggerEmergencyLockDown(Data: any): Observable<IItem[]> {
    let Url = this.BaseUrl + "WirelessTask/SK_EmergencyLockDown";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, Data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }


  SK_GetStatus(Data: any): Observable<IItem[]> {
    let Url = this.BaseUrl + "InfoComm/GetInfoComm";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, Data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }

  /* email........... Save, Get, v1/EmailMngt/SaveEmailTemplate/ */


  SK_GetTempl(Sys: number): Observable<IEmailTmplates> {
    let Url = ApiConstant.baseUrlV4 + "EmailMngt/GetEmailTemplates";
    this.GetTK();

    return this.httpClient.get<IEmailTmplates>(Url + "/" + Sys, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }


  SK_UpdateTemplate(Data: any): Observable<IItem[]> {
    let Url = this.BaseUrl + "EmailMngt/SaveEmailTemplate";
    this.GetTK();

    return this.httpClient.post<IItem[]>(Url, Data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }

  SK_GetEmailList(Sys: number): Observable<IEmails[]> {
    let Url = this.BaseUrl + "EmailMngt/GetSkyAccessEmails";
    this.GetTK();

    return this.httpClient.get<IEmails[]>(Url + "/" + Sys, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }


  SK_GetAccUser(Data: string): Observable<any> {
    let Url = this.BaseUrl + "Person/GetAccUser?cypher=" + Data;
    this.GetTK();
    return this.httpClient.post<string>(Url, Data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.TmpTk
      })
    }).pipe(catchError(this.handleError));

  }


  // getItemsGet(): Observable<IItem[]> {
  //   return this.httpClient.get<any>(this.BaseUrl, { 
  //   })
  //   .pipe(catchError(this.handleError));
  // }

  // OpenDoor(): Observable<any> { 
  //   return this.httpClient.get<any>(this.BaseUrl, { 
  //   })
  //   .pipe(catchError(this.handleError));
  // }

  // getEmployee(id: number): Observable<IItem> {
  //   return this.httpClient.get<IItem>(`${this.BaseUrl}/${id}`)
  //       .pipe(catchError(this.handleError));
  // }

  // updateEmployee(employee: IItem): Observable<void> {
  //   return this.httpClient.put<void>(`${this.BaseUrl}/${employee.id}`, employee, {
  //       headers: new HttpHeaders({
  //           'Content-Type': 'application/json'
  //       })
  //   })
  //       .pipe(catchError(this.handleError));
  // }

  // deleteEmployee(id: number): Observable<void> {
  //   return this.httpClient.delete<void>(`${this.BaseUrl}/${id}`)
  //       .pipe(catchError(this.handleError));
  // }


  //#endregion


}
